class CharryConverter {

    toCharry = (amtCHY) => {
        const inCHYCents = parseFloat(amtCHY);
        const inCharry = (inCHYCents / 10 ** 16).toFixed(16)
        return inCharry.toString()
    }

    fromCharry = (amtCHY) => {
        const inCHY = parseFloat(amtCHY)
        const inCHYCents = Math.floor(inCHY * 10 ** 16)
        return inCHYCents.toString()
    }

}

export default new CharryConverter()